import React from 'react';
import { noop } from 'lodash-es';
import styled from 'styled-components';

import { evaluateProp } from '../utils';

const Button = styled.button<{ width: string | number; height: string | number }>`
  width: ${(props) => evaluateProp(props.width)};
  height: ${(props) => evaluateProp(props.height)};
  display: inline-block;
  overflow: hidden;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

interface FjIconProps {
  className?: string;
  icon: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  alt?: string;
  inline?: boolean;
  viewBox?: string;
  height?: string | number;
  width?: string | number;
}

const FjIcon = ({
  className = '',
  icon,
  onClick = noop,
  alt,
  inline = false,
  viewBox = '0 0 15 15',
  height = '25px',
  width = '25px',
}: FjIconProps) => (
  <Button onClick={onClick} width={width} height={height} className={className}>
    {inline ? (
      <svg
        height={evaluateProp(height)}
        width={evaluateProp(width)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        aria-labelledby={alt}
      >
        {icon}
      </svg>
    ) : (
      <img src={icon as string} alt={alt} style={{ height, width }} />
    )}
  </Button>
);

export default FjIcon;
